import EU from '../assets/regions/EU.png';
import US from '../assets/regions/US.png';

export const REGIONS = {
  US: { name: 'North America', icon: US },
  EU: { name: 'Europe', icon: EU },
};
